/**
 * Original-data plot + slope plot directly beneath, collapsible.
 * Mirrors the layout from `anomaly_detection_1.py` L668-724.
 *
 * The two charts share a `sharedBrushRange` state so zooming/panning one
 * follows the other. The slope plot renders in red to visually distinguish
 * it from the blue original.
 */
import React, { useState } from 'react';
import { PlotData } from '../types';
import AnomalyChart from './AnomalyChart';
import SlopeCollapsiblePlot from './SlopeCollapsiblePlot';

const SLOPE_COLOR = '#ef4444';

interface Props {
  original: PlotData;
  slope: PlotData;
}

const OriginalDataSection: React.FC<Props> = ({ original, slope }) => {
  const [sharedBrushRange, setSharedBrushRange] = useState<
    { startTime: number; endTime: number } | null
  >(null);

  return (
    <div className="mt-6">
      <AnomalyChart
        plot={original}
        hidePointsToggle
        sharedBrushRange={sharedBrushRange}
        onSharedBrushChange={setSharedBrushRange}
      />
      <SlopeCollapsiblePlot
        slope={slope}
        color={SLOPE_COLOR}
        sharedBrushRange={sharedBrushRange}
        onSharedBrushChange={setSharedBrushRange}
      />
    </div>
  );
};

export default OriginalDataSection;
